
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { Pie } from "vue-chartjs";

@Component({
  extends: Pie
})
export default class ExpensesReportGraphEstimates extends Mixins(Pie) {
  @Prop({ required: true }) labels!: string[];
  @Prop({ required: true }) estimates!: number[];
  @Prop({ required: true }) expenses!: number[];
  @Prop({ required: true }) colors!: string[];

  mounted() {
    // 印刷時に黒塗りになってしまうのを防ぐ
    this.addPlugin({
      id: "custom-background-color",
      beforeDraw: (chart: any) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    });

    this.init();
  }

  @Watch("graphData")
  private init() {
    this.renderChart(this.graphData, {
      // 表示オプションを指定
      // cutoutPercentage: 50,
      responsive: true,
      maintainAspectRatio: false,

      legend: {
        display: false
        // position: "top"
      },
      title: {
        display: true,
        text: "経費"
      },
      tooltips: {
        callbacks: {
          label(item, data) {
            const formatter = Intl.NumberFormat("ja-JP", {
              style: "currency",
              currency: "JPY"
            });
            return (
              data.labels![item.index!] +
              ": " +
              formatter.format(Number(data.datasets![0].data![item.index!]))
            );
          }
        }
      }
    });
  }

  // グラフの色分けを props の colors からループ指定 (ScriptableContext)
  private setColor(graphItem?: any) {
    var index = graphItem.dataIndex;
    return this.colors[index % this.colors.length];
  }

  private get graphData() {
    return {
      labels: this.labels,
      datasets: [
        {
          backgroundColor: this.setColor,
          data: this.expenses
        }
      ]
    };
  }
}
